import { createContext, SetStateAction } from 'react'

import { DashboardWidget } from '@/store/dashboard-widgets/types'

export type WidgetsContextType = {
  savedWidgetIds: string[]
  setSavedWidgetIds: (ids: SetStateAction<string[]>) => void
  reorderedWidgets: DashboardWidget[]
}

export const WidgetsContext = createContext<WidgetsContextType | null>(null)
